export const CONTACT = {
    title: "Contact Me",
    subtitle: "My",
    typeWriter: ["Contact"],
    text: "If you have any suggestion, project or even you want to say “hello”, please fill out the form below and I will reply you shortly.",
    location: "Dinajpur, Rangpur, Dhaka,",
    country: "Bangladesh",
    email: "nayannk103@gmail.com",
    phone: "+880 1314138781",
}